import { createApi } from '@reduxjs/toolkit/query/react';
import apiBaseQuery from './axiosBaseQuery'
export const COUNTRIES_API_REDUCER_KEY = 'countriesApi';


export const countriesApi = createApi({
    reducerPath: COUNTRIES_API_REDUCER_KEY,
    baseQuery: apiBaseQuery,
    tagTypes: ['countries'],
    endpoints: (builder) => ({
        getAllCountries: builder.query({
            query: ({ page, q, limit, sort }) => ({
                url: `admin/repository/countries?page=${page}&q=${q}&limit=${limit}&sort=${sort}`
            }),
            providesTags: ['countries']
        }),
        getCountries: builder.query({
            query: (id) => ({
                url: `admin/repository/countries/${id}`
            }),
            providesTags: ['countries']
        }),
        createCountries: builder.mutation({
            query: (body) => ({
                url: `admin/repository/countries`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['countries']
        }),
        updateCountries: builder.mutation({
            query: ({ id, ...rest }) => ({
                url: `admin/repository/countries/${id}`,
                method: 'PUT',
                body: rest,
            }),
            invalidatesTags: ['countries']
        }),
    })
});

export const {
    useGetAllCountriesQuery,
    useGetCountriesQuery,
    useCreateCountriesMutation,
    useUpdateCountriesMutation,
} = countriesApi;